import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { User } from "../../../../domain/user";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { Socket } from "../../../../infrastructure/socket.service";
import { UI } from "../../../../services/ui.service";
import { Block } from "../../../../domain/blocks/block";
import { IBlockRepository } from "../../../../domain/blocks/i-block.repository";

@Component({
  selector: "evrideo-block-library-item",
  templateUrl: "./block-library-item.component.html",
  styleUrls: ["./block-library-item.component.scss"],
})
export class BlockLibraryItemComponent implements OnInit {
  @Input()
  item: Block;

  @Input()
  currentUser: User;

  @Input()
  viewMode = "gallery";

  menuOpen = false;
  dragged = false;

  blockUpdatedSubscription: Subscription;

  @Output()
  deleteEmitter = new EventEmitter();

  constructor(
    private ref: ElementRef,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private socketService: Socket,
    private ui: UI,
    private _blocksRepository: IBlockRepository,
  ) {}

  ngOnInit() {
    this.ref.nativeElement.addEventListener(
      "dragstart",
      this.onDragStart.bind(this),
      false,
    );
    this.ref.nativeElement.addEventListener(
      "dragend",
      this.onDragEnd.bind(this),
      false,
    );

    this.blockUpdatedSubscription = this._blocksRepository.updated.subscribe(
      this.onBlockUpdated.bind(this),
    );
  }
  onBlockUpdated(block: Block) {
    if (this.item.id === block.id) {
      this.item = block;
      this.changeDetectorRef.markForCheck();
    }
  }

  delete() {
    this.ui.notify(this.ui.EVENTS.ShowConfirm, {
      title: "Delete block " + this.item.name,
      message: "Are you sure about that?",
      buttons: [
        {
          title: "Yes",
          callback: this.onDeleteConfirmed.bind(this),
        },
        {
          title: "No",
          callback: this.onDeleteCancelled.bind(this),
        },
      ],
    });
  }

  onDeleteConfirmed() {
    this.deleteEmitter.emit();
  }

  onDeleteCancelled() {}

  edit() {
    this.router.navigate(["/blocks/edit/", this.item.id]);
  }

  onDragStart(event: DragEvent) {
    this.dragged = true;
    event.dataTransfer.setData("text/block", JSON.stringify(this.item));
    event.dataTransfer.dropEffect = "copy";
  }

  onDragEnd(event) {
    this.dragged = false;
  }

  ngOnDestroy(): void {
    if (this.blockUpdatedSubscription) {
      this.blockUpdatedSubscription.unsubscribe();
    }
  }
}
